import { render, staticRenderFns } from "./ConnectionLabel.vue?vue&type=template&id=d21b2d72&scoped=true"
import script from "./ConnectionLabel.vue?vue&type=script&lang=js"
export * from "./ConnectionLabel.vue?vue&type=script&lang=js"
import style0 from "./ConnectionLabel.vue?vue&type=style&index=0&id=d21b2d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21b2d72",
  null
  
)

export default component.exports